import React, {Component} from 'react'

import styled from '@emotion/styled'
import sv from '../styles/marketing'
import AuthFormField from './AuthFormField'
import {Link, withRouter} from "react-router-dom";

import {connect} from 'react-redux';
import {alertActions, userActions} from '../_actions'

import {Trans, withTranslation} from 'react-i18next'
import {__isAvailable, userHelper} from "../_helpers";
import {alertActionTypes} from "../_constants";
import AuthError from "./AuthError";
import {faCheck} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {AnimatedLoader} from "../styles/CommonStyler";

// STYLE ##########################################################

const Form = styled(`div`)`
  flex: 1;
  ${sv.flexCenter};
  margin-bottom: 20px;
`;

const Container = styled(`div`)`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: ${props => props.maxWidth ? props.maxWidth : '400px'};
`;

const TopMarginBlock = styled(`div`)`
  margin-top: 24px;
`;

const Title = styled(TopMarginBlock)`
  ${sv.h1};
  color: ${sv.colors.headline};
`;

const SubTitle = styled(TopMarginBlock)`
  font-size: 16px;
`;

const Features = styled(TopMarginBlock)`
`;

const Feature = styled(`div`)`
  font-size: 13px;
  padding: 2px 0;
`;

const FormContainer = styled(`div`)`
  padding: 0 24px 24px 24px;
`;

const Alert = styled(TopMarginBlock)`
`;

const Actions = styled(`div`)`
  margin-top: 24px;
  ${sv.flexRow};
  justify-content: center;
`;

const AcceptBox = styled(`input`)`
  margin-right: 10px;
`;

const Options = styled(`div`)`
  ${sv.label};
  text-transform: none;
  margin-top: 24px;
  ${sv.flexCenter};
`;

const Or = styled(`div`)`
  color: ${sv.colors.grey};
  margin-right: 4px;
  text-align: center;
  a {
    color: ${sv.colors.body};
    white-space: nowrap;
  }
`;

const PitchButton = styled(`div`)`
  font-size: 15px;
  ${sv.buttonBase};
  background: ${props => props.brightColor ? 'rgba(255,255,255,.75)' : sv.colors.cta};
  min-width: ${props => props.minWidth ? props.minWidth : ''};
  color: ${props => props.brightColor ? sv.colors.body : sv.colors.light};
  box-shadow: 0 2px 4px rgba(0,0,0,.05);
  border: ${props => props.brightColor ? ('2px ' + sv.colors.subtleGrey + ' solid') : ''};
  &:hover {
    box-shadow: 0 3px 6px rgba(0,0,0,.1);
  }
`;

const ModalLink = styled(Link)`
  cursor:pointer;
  color: ${sv.colors.darkerGray}
`;

// COMPONENT ##########################################################

class CreateAccount extends Component {

    constructor(props) {
        super(props);

        this.state = {
            email: '',
            password: '',
            accept: false,
        };
    
        this.handleChange = this.handleChange.bind(this);
        this.handleAccept = this.handleAccept.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.setupAccount = this.setupAccount.bind(this);
    }

    handleChange(e) {
        const {name, value} = e.target;
        this.setState({[name]: value});
    }
    
    handleAccept() {
        const {t} = this.props;
        this.setState({accept: !this.state.accept});
        this.props.dispatchSuccessError({"successMsg": t("Terms and privacy policy has been accepted for SignUp.")});
    }
    
    getSelectedPlanUuid = () => {
        // fetch uuid from url, if any
        const searchParams = new URLSearchParams(window.location.search);
        const planUuid = searchParams.get('uuid');
        const plan = userHelper.getPlanByUuid(planUuid);
        
        return __isAvailable(plan)
                ? planUuid
                : "";
    }
    
    getSignUpPlanInfo = () => {
        const planUuid = this.getSelectedPlanUuid();
        return userHelper.getPlanInfoForSignUp(planUuid)
    }

    setupAccount(email, password) {
        const {t} = this.props;
        if(!this.state.accept) {    // if not accepted, then raise error
            this.props.dispatchEmptyFieldError({"errorMsg": t("Please accept the terms and privacy policy.")});
        } else {
            const planUuid = this.getSelectedPlanUuid();    // if plan is selected, the uuid else falls back to empty
            this.props.createAccount(email, password, planUuid);
        }
    }

    handleSubmit(e) {
        e.preventDefault();

        const {email, password} = this.state;
        this.setupAccount(email, password);
    }

    render() {
        const {alert, t, registration} = this.props;
        const planInfo = this.getSignUpPlanInfo();
        const isRequestOngoing = registration && registration.isLoading;

        return (
                <Form>
                    <Container>
                        {/* Title */}
                        <Title>{t(planInfo.header)}</Title>
                        
                        {/* Sub-Title */}
                        <SubTitle>{t(planInfo.intro)}</SubTitle>
                        
                        {/* Features */}
                        <Features>
                            {planInfo.features.map((feature, i) =>
                                    <Feature key={i}>
                                        <FontAwesomeIcon icon={faCheck} style={{marginRight: 5}} color={sv.colors.cta}/>
                                        {t(feature)}
                                    </Feature>)
                            }
                        </Features>
                        
                        {/* Form Elements */}
                        <FormContainer>
                            {/* Alerts */}
                            <Alert>
                            {
                                alert.type === alertActionTypes.ERROR &&
                                <AuthError error={alert.message.errorMsg}/>
                            }
                            </Alert>
                            
                            {/* Email */}
                            <AuthFormField
                                    label='Email'
                                    placeholder='bob@smith.com'
                                    update={this.handleChange}
                                    name="email"
                                    onEnterPressed={this.handleSubmit}
                                    disabled={isRequestOngoing}
                            />
                            
                            {/* Password */}
                            <AuthFormField
                                    password
                                    label={t('Password (6 character min)')}
                                    placeholder={t('Enter password')}
                                    update={this.handleChange}
                                    name="password"
                                    onEnterPressed={this.handleSubmit}
                                    disabled={isRequestOngoing}
                            />
                            
                            {/* Acceptance */}
                            <Options>
                                <Or>
                                    <AcceptBox type={"checkbox"} checked={this.state.accept} onChange={this.handleAccept} disabled={isRequestOngoing}/>
                                    <Trans i18nKey="express_consent">
                                        I agree to the <ModalLink to={{pathname: "/terms"}} target="_blank">Terms of Services</ModalLink> and <ModalLink to={{pathname: "/privacy"}} target="_blank">Privacy Policy</ModalLink>
                                    </Trans>
                                </Or>
                            </Options>
    
                            {/* Action buttons */}
                            <Actions>
                                {/* when not loading */}
                                {!isRequestOngoing &&
                                <PitchButton onClick={this.handleSubmit} minWidth={'150px'}>{t('Get Started')}</PitchButton>
                                }
                                {/* loader when request in ongoing */}
                                {isRequestOngoing &&
                                <PitchButton minWidth={'150px'}><AnimatedLoader color={sv.colors.light} /></PitchButton>
                                }
                            </Actions>
                        </FormContainer>
                    </Container>
                </Form>
        )
    }

}

function mapStateToProps(state) {
    const { alert, registration } = state;
    return {
        alert, registration
    };
}

function mapDispatchToProps(dispatch) {
    return {
        createAccount: (email, password, plan, paymentToken) => dispatch(userActions.createAccount(email, password, plan, paymentToken)),
        clearRegistration: () => dispatch(userActions.clearRegistration()),
        dispatchEmptyFieldError: (msg) => dispatch(alertActions.error(msg)),
        dispatchSuccessError: (msg) => dispatch(alertActions.success(msg))
    }
}

const connectedCreateAccount = withTranslation()(withRouter(connect(mapStateToProps, mapDispatchToProps)(CreateAccount)));
export { connectedCreateAccount as CreateAccount };
